module.exports = __webpack_public_path__ + "img/contractor_contact.16895f41.svg";